import { fileLengthFormat } from '/@/api/material/materialModel'
export default {
  updateSpaceSize(state, info: { spaceId: string; size: number }) {
    const { spaceId, size } = info
    console.log(info)
    if (spaceId && spaceId != '') {
      if (state.currentSpaceItem.space_id == spaceId) {
        const total_volume = state.currentSpaceItem.total_volume
        console.log(total_volume)
        state.currentSpaceItem.remain_volume -= size
        const used = total_volume - state.currentSpaceItem.remain_volume
        state.currentSpaceItem.used = fileLengthFormat(used, 1)
        state.currentSpaceItem.percent_volume = total_volume ? (used * 100) / total_volume : 0
      }
    }
  },
  setSpaceItem(state, item: CShareDiskNS.ShareSpaceItem | null) {
    if (!item) {
      state.currentSpaceItem = null
      return
    }
    state.currentSpaceItem = item
  },
  setTmpToken(state, item: CShareDiskNS.tmpToken | null) {
    if (!item) {
      state.tmpToken = null
      return
    }
    state.tmpToken = item
  },
  setShowUploadList(state, condition: boolean) {
    state.showUploadList = condition
  },
  setNoUpload(state, condition: boolean) {
    state.noUpload = condition
  },
  setBatchDown(state, condition: boolean) {
    state.batchDown = condition
  },
  setSelectRow(state, selectedItem: CShareDiskNS.SelectItem) {
    state.selectedRow = selectedItem
  },
  setSpaceId(state, space_id?: string) {
    if (space_id && space_id != '') {
      state.currentSpaceId = space_id
      return
    }
  },
  clear(state) {
    console.log('useAccountStore clear')
    state.currentSpaceId = null
  },
}
